import { useMemo } from 'react';
import { useDesignStore } from './designStore';
import { usePreviewReceiver } from '../shared/usePreviewReceiver';

/**
 * Custom hook to listen for real-time ClientRender design configuration updates
 * sent from Bigfoot Dashboard via window.postMessage.
 */
export const useDesignLivePreview = () => {
    const handlers = useMemo(
        () => ({
            BIGFOOT_DESIGN_PREVIEW_UPDATE: (payload: any) => {
                useDesignStore.getState().updateLocalConfig(payload);
            },
        }),
        []
    );

    usePreviewReceiver({ handlers });
};

export default useDesignLivePreview;
